import axios from "axios";
import {APP_URLS, STORAGE} from "../app/config";
import { logout } from '../app/slices/authSlice';
import { Buffer } from 'buffer';

export const apiClient = axios.create({
    baseURL: APP_URLS.BASE,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
});

apiClient.interceptors.request.use((config) => {
    const auth = JSON.parse(localStorage.getItem(STORAGE.ACCESS_TOKEN_KEY));
    if (auth?.token) {
        config.headers.Authorization = `Bearer ${auth.token}`;
    }
    return config;
});

export const setupInterceptors = (store) => {
    apiClient.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalRequest = error.config;
            console.log('[apiClient] 🚀 ', JSON.stringify(error.response, null, 2));
            if (error.response?.status === 401 && !originalRequest._retry) {
                console.log('[apiClient] 🚀 ', JSON.stringify(error.response.status, null, 2));
                originalRequest._retry = true;
                try {
                    const refreshToken = localStorage.getItem(STORAGE.REFRESH_TOKEN_KEY);
                    if (!refreshToken) {
                        store.dispatch(logout());
                        return Promise.reject(new Error("No refresh token found"));
                    }

                    const params = new URLSearchParams();
                    params.append('grant_type', 'refresh_token');
                    params.append('refresh_token', refreshToken);

                    // Use a direct axios call to avoid interceptor recursion
                    const response = await axios.post(APP_URLS.REFRESH_TOKEN, params, {
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    });
                    const responseData = response.data;
                    console.log('[responseData] 🚀 ', JSON.stringify(responseData, null, 2));

                    if (responseData.access_token) {
                        localStorage.setItem(STORAGE.ACCESS_TOKEN_KEY, JSON.stringify({ token: responseData.access_token }));

                        if (responseData.hasOwnProperty('refresh_token')) {
                            localStorage.setItem(STORAGE.REFRESH_TOKEN_KEY, responseData.refresh_token);
                        }
                        
                        // Retry the original request with the new token
                        return apiClient(originalRequest);
                    } else {
                        // The refresh response didn't contain the expected access_token
                        store.dispatch(logout());
                        return Promise.reject(responseData);
                    }
                } catch (e) {
                    // This will catch errors from the axios.post call (e.g., network error, 500, or invalid refresh token)
                    store.dispatch(logout());
                    return Promise.reject(e);
                }
            }
            return Promise.reject(error);
        }
    );
}